/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Practice_Session_Chat_StartingInputs */



/**
* | output |
* | --- |
* | "{name} is about to start…" |
*
* @param {Practice_Session_Chat_StartingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_chat_starting = /** @type {((inputs: Practice_Session_Chat_StartingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Chat_StartingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`${i?.name} begint zo…`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.name} va commencer…`)
	return /** @type {LocalizedString} */ (`${i?.name} is about to start…`)
});